'use strict'

module.exports = {
  EQUAL: 1,
  TRIANGULAR: 2,
  EXPONENTIAL: 3,
  FACTORIAL: 4,
};
